import { CircularProgress } from "@material-ui/core";

import { InformationContainerLayout } from "./InformationContainerLayout";
import { InformationContainerLayoutProps } from "./type";

export const Loading: React.FC<InformationContainerLayoutProps> = (props) => {
  const { position, flexDirection } = props;
  return (
    <InformationContainerLayout
      position={position}
      flexDirection={flexDirection}
    >
      <CircularProgress />
    </InformationContainerLayout>
  );
};
